import PhoneInputWithLabel from './PhoneInputWithLabel';

export default PhoneInputWithLabel;
